import { Alert } from 'antd'

import { classNames } from '@/Ship/Helpers/classNames'

import type { DiskTextPreview } from '../Stores/FileViewerStore'

import styles from './DiskFileViewer.module.css'

const DELIMITER_LABEL: Record<string, string> = { ',': 'кома', ';': 'крапка з комою', '\t': 'табуляція' }

/**
 * Текст, Markdown і код — моноширинним як є (Markdown не рендеримо: це
 * простий текст, без HTML); JSON — з відступами; CSV — таблицею, перший
 * рядок — заголовок.
 */
export const DiskTextView = ({ preview }: { preview: DiskTextPreview }) => {
    if (preview.mode === 'csv') {
        const { table } = preview
        const [head, ...body] = table.rows
        const columns = Array.from({ length: table.columns }, (_, index) => index)

        return (
            <div className={classNames(styles['textScroll'])} data-testid="disk-viewer-csv">
                <div className={classNames(styles['caption'])} data-testid="disk-viewer-csv-caption">
                    {table.totalRows > table.rows.length
                        ? `Показано перші ${body.length} рядків з ${table.totalRows - 1} — решта у скачаному файлі. `
                        : `Рядків: ${body.length} (без заголовка). `}
                    Роздільник — {DELIMITER_LABEL[table.delimiter] ?? table.delimiter}.
                </div>
                <div className={classNames(styles['tableWrap'])}>
                    <table className={classNames(styles['table'])}>
                        {head && (
                            <thead>
                                <tr>
                                    <th className={classNames(styles['rowNumber'])}>#</th>
                                    {columns.map((index) => (
                                        <th key={index}>{head[index] ?? ''}</th>
                                    ))}
                                </tr>
                            </thead>
                        )}
                        <tbody>
                            {body.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td className={classNames(styles['rowNumber'])}>{rowIndex + 1}</td>
                                    {columns.map((index) => (
                                        <td key={index}>{row[index] ?? ''}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    return (
        <div className={classNames(styles['textScroll'])} data-testid="disk-viewer-text">
            {preview.mode === 'json' && !preview.parsed && (
                <Alert
                    className={classNames(styles['notice'])}
                    type="warning"
                    showIcon
                    title="Файл не розбирається як JSON — показано як є"
                />
            )}
            <pre className={classNames(styles['code'])}>{preview.text}</pre>
        </div>
    )
}
